import Styled from "styled-components";

export const SocialProofContainer = Styled.a`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  justify-content: center;
  max-width: 100%;
  gap: 1rem;
  padding: 2rem;
  border: 1px solid ${(props) =>
    props.theme.mode === "light" ? "#E8E8E8" : "#212121"} ;
  border-radius: 0.75rem;
  text-decoration: none;

  ${(props) => props.theme.breakpoints.up("medium")} {
    gap: 1.25rem;
  }
`;

export const SocialProofContent = Styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.75rem;
  width: 100%;
`;

export const Illustration = Styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.75rem;
  height: 2.75rem;
  border-radius: 50%;

  > img {
    width: 2.75rem;
  }
`;

export const UserInfo = Styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  gap: 2px;
`;

export const NameAndVerifiedContainer = Styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0.25rem;
`;

export const VerifiedTagIcon = Styled.img`
  width: 1rem;
  height: 1rem;
`;

export const IconContainer = Styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export interface IconProps {
  $isHovered: boolean;
}

export const Icon = Styled.img<IconProps>`
  width: 1.5rem;
  height: 1.5rem;
  opacity: ${(props) => (props.theme.mode === "light" ? "0.3" : "0.6")};
  transition: opacity 300ms ease;

  ${(props) =>
    props.$isHovered &&
    `
    opacity: 1;
  `}
`;

export const Quote = Styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
`;
